<template>
  <v-dialog persistent v-model="dialog" max-width="500px">
    <v-btn slot="activator" flat icon class="mb-2">
      <v-icon>add_circle_outline</v-icon>
    </v-btn>

    <v-card v-if="userCreated">
      <v-card-title primary-title>
        <div>
          <h3 class="headline mb-0">User Created!</h3>
        </div>
      </v-card-title>

      <v-card-text>
        <v-text-field
          v-model="createdRealName"
          label="Realname"
          readonly
        ></v-text-field>

        <v-text-field
          v-model="createdUserName"
          label="Username"
          readonly
        ></v-text-field>

        <v-text-field
          v-model="createdPassword"
          label="Password"
          readonly
        ></v-text-field>

        <p class="text-xs-center">Write down this information somewhere safe.</p>

      </v-card-text>

      <v-card-actions>
        <v-btn flat @click.native="dialog = false">Close</v-btn>
      </v-card-actions>
    </v-card>
    <v-card ref="form" v-else>
      <v-card-text>

        <v-text-field
          ref="realname"
          v-model="realname"
          :rules="[() => !!realname || 'This field is required']"
          :error-messages="errorMessages"
          label="Full Name"
          placeholder="John Doe"
          required
        ></v-text-field>

        <v-text-field
          ref="username"
          v-model="username"
          :rules="[() => !!username || 'This field is required']"
          :error-messages="errorMessages"
          label="Username/E-Mail"
          placeholder="john@doe.com"
          required
        ></v-text-field>

        <p class="text-xs-center">A password will be automatically generated for the user, in which they will be
          forced to change upon initial login.</p>

      </v-card-text>

      <v-divider class="mt-5"></v-divider>

      <v-card-actions>
        <v-btn flat @click.native="dialog = false">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-slide-x-reverse-transition>
          <v-tooltip
            v-if="formHasErrors"
            left
          >
            <v-btn
              slot="activator"
              icon
              class="my-0"
              @click="resetForm"
            >
              <v-icon>refresh</v-icon>
            </v-btn>
            <span>Refresh form</span>
          </v-tooltip>
        </v-slide-x-reverse-transition>
        <v-btn flat @click="createUser">Submit</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
  import generator from 'generate-password'
  import gfycat from 'gfycat-style-urls'

  export default {
    name: "CreateUserDialog",
    data() {
      return {
        dialog: false,
        formHasErrors: false,
        realname: '',
        username: '',
        errorMessages: [],
        userCreated: false,
        createdUserName: '',
        createdRealName: '',
        createdPassword: ''
      }
    },
    computed: {
      form() {
        return {
          realname: this.realname,
          username: this.username
        }
      }
    },
    methods: {
      editUser(name) {
        console.log('EDIT USER ' + name)
      },
      close() {
        this.dialog = false
        this.userItem = {
          realname: '',
          username: '',
          password: '',
          role: ''
        }
      },
      save() {
        var userToCreate = this.userItem

        this.close()
      },
      loadUserList() {
        this.$emit('updateUserList')
      },
      createUser() {
        this.formHasErrors = false

        Object.keys(this.form).forEach(f => {
          if (!this.form[f]) this.formHasErrors = true

          this.$refs[f].validate(true)
        })

        if (!this.realname || !this.username) {
          this.$root.$emit('snackbar', "Fields cannot be empty!")
          return;
        }
        //var password = generator.generate({length: 8, numbers: true})
        var password = gfycat.generateCombination(1, "").toLowerCase()

        var userObj = {username: this.username, realname: this.realname, password: password}

        this.$http.post('/auth/register', userObj, {
          headers: {
            'Authorization': localStorage.getItem('jwtToken')
          }
        })
          .then(response => {
            if (response.data.success) {
              this.createdUserName = this.username;
              this.createdRealName = this.realname;
              this.createdPassword = password

              this.username = '';
              this.realname = '';

              this.userCreated = true;
            } else {
              this.$root.$emit('snackbar', response.data.msg)
            }

          })
          .catch(e => {
            // console.log(JSON.stringify(e));
            this.$root.$emit('snackbar', e.response.data.msg)
          })
      },
      resetForm() {
        this.errorMessages = []
        this.formHasErrors = false

        Object.keys(this.form).forEach(f => {
          this.$refs[f].reset()
        })
      }
    },
    mounted() {
      this.loadUserList()
    },
    watch: {
      dialog: function (newState, oldState) {
        this.realname = '';
        this.username = '';
        this.createdUserName = '';
        this.createdPassword = '';
        this.createdRealName = '';
        this.loadUserList();
        this.errorMessages = [];
        this.formHasErrors = false;
        this.userCreated = false;
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dialogs/CreateUserDialog.vue